import Axios from 'helpers/http'
import generateOrbitHostname from 'helpers/http/generateOrbitHostname'

import { VERSION_TWO_API_PREFIX } from '../../constants'

const OrbitApiV2 = new Axios(generateOrbitHostname(), VERSION_TWO_API_PREFIX)

export default OrbitApiV2
